import { useState } from "react";
import { useAuth } from "../lib/auth";
import { useNavigate } from "react-router-dom";
import { formatApiErrorDetail } from "../lib/api";
import { Sparkle } from "@phosphor-icons/react";

export default function Login() {
    const { login } = useAuth();
    const nav = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [err, setErr] = useState("");
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true); setErr("");
        try {
            await login(email, password);
            nav("/");
        } catch (e) {
            setErr(formatApiErrorDetail(e.response?.data?.detail) || e.message);
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="min-h-screen grid lg:grid-cols-2" style={{ background: "var(--bone)" }}>
            {/* Left: hero */}
            <div className="hidden lg:flex relative flex-col justify-between overflow-hidden">
                <img
                    src="https://images.unsplash.com/photo-1624706495494-7a143e8ed526?auto=format&fit=crop&w=1600&q=80"
                    alt="Newcastle NSW coastline"
                    className="absolute inset-0 w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/40 to-black/70" />
                <div className="relative z-10 p-12">
                    <div className="text-[10px] tracking-[0.3em] uppercase text-white/80 mb-3">
                        Est. 2026 · Newcastle NSW
                    </div>
                    <h1 className="font-serif text-white text-5xl leading-tight tracking-tight">
                        Andrews<br />Financial Planner
                    </h1>
                </div>
                <div className="relative z-10 p-12" />
            </div>

            {/* Right: form */}
            <div className="flex items-center justify-center p-10">
                <form onSubmit={submit} className="w-full max-w-sm" data-testid="login-form">
                    <div className="label-eyebrow mb-3">Sign in</div>
                    <h2 className="font-serif text-4xl mb-1 tracking-tight">Welcome back.</h2>
                    <p className="text-[var(--muted)] text-sm mb-6">
                        Enter your details to access your family office.
                    </p>

                    <label className="label-eyebrow block mb-2">Email</label>
                    <input
                        data-testid="login-email"
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="w-full border border-[var(--line)] bg-white px-4 py-3 rounded mb-5 focus:outline-none focus:border-[var(--eucalyptus)]"
                        required
                    />
                    <label className="label-eyebrow block mb-2">Password</label>
                    <input
                        data-testid="login-password"
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="w-full border border-[var(--line)] bg-white px-4 py-3 rounded mb-6 focus:outline-none focus:border-[var(--eucalyptus)]"
                        required
                    />
                    {err && (
                        <div data-testid="login-error" className="text-sm text-[var(--terracotta)] mb-4">
                            {err}
                        </div>
                    )}
                    <button
                        type="submit"
                        disabled={busy}
                        data-testid="login-submit"
                        className="btn-primary w-full disabled:opacity-60"
                    >
                        {busy ? "Signing in…" : "Sign in"}
                    </button>

                    <div className="mt-10 pt-6 border-t border-[var(--line)] text-xs text-[var(--muted)]">
                        <div className="label-eyebrow mb-2">Family &amp; advisers</div>
                        Three seeded roles: <span className="text-[var(--ink)]">Owner</span>,{" "}
                        <span className="text-[var(--ink)]">Spouse</span>,{" "}
                        <span className="text-[var(--ink)]">Accountant</span>.
                    </div>
                </form>
            </div>
        </div>
    );
}
